import React from "react";
import classNames from "classnames";

import "./bookingSourceLogo.scss";

interface IBookingSourceLogoProps {
  source?: string;
  withBackground?: boolean;
}

export default function BookingSourceLogo({ source, withBackground = false }: IBookingSourceLogoProps) {
  if (!source) {
    return null;
  }

  const BOOKING_SOURCE_LOGOS: Record<string, string> = {
    golfnow: "/public/images/gn-logo-small.svg",
    play_golf_canada: "/public/images/play_golf_canada_logo.png",
    // integolf:
  };

  const logo = BOOKING_SOURCE_LOGOS[source];

  if (!logo) {
    return null;
  }

  return (
    <div
      className={classNames("booking-source-logo", {
        "booking-source-logo--with-background": withBackground,
      })}
    >
      <img src={logo} alt={source} />
    </div>
  );
}
